var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTerraform(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#5C4EE5;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#4040B2;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.549621 0 0 .549621 6.171141 42.722741)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M119.5,21.1v-0.2L94.6,6.6v28.7l24.9,14.4V21.1z M119.5-11v28.7L94.6,3.4v-28.7L119.5-11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.2,17.8l24.9-14.4v-28.7L122.2-11V17.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67-12.6L91.9,1.7V-27L67-41.3V-12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M136.6,30.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.6,6.6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerraform);
export default __webpack_public_path__ + "static/media/Terraform.51899379d0de1f26bb85625bdf02d889.svg";
export { ForwardRef as ReactComponent };